import { productFromStatus } from '@/shbdeployer/product';

/** Публичные сведения об установке (GET /api/status). */
export function StatusViewModel(data) {
  this.Authentication = data.Authentication;
  this.Snapshot = data.Snapshot;
  this.Version = data.Version;
  this.InstanceID = data.InstanceID;
  this.Product = productFromStatus(data);
}

/** Результат проверки обновлений (GET /api/status/version). */
export function StatusVersionViewModel(data) {
  this.UpdateAvailable = data.UpdateAvailable;
  this.LatestVersion = data.LatestVersion;
}
